import { render } from "./ReaderPanel.vue?vue&type=template&id=fbea5e30"
import script from "./ReaderPanel.vue?vue&type=script&lang=js"
export * from "./ReaderPanel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__